<template>
  <el-dialog
    @open="onOpen"
    title="Selecionar Administradora"
    :visible.sync="visibility"
    :before-close="fechar"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
    width="60%"
  >
    <el-form size="mini" label-position="top">
      <el-row>
        <el-col>
          <el-form-item label="Nome">
            <el-input v-model="administradoraPesquisa.nome" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-row type="flex" justify="end">
      <h4 style="color: #606266; margin: 0px 15px 5px 0px">{{ this.labelQuantidade }}</h4>
    </el-row>

    <el-table
      :data="administradorasFiltradas"
      highlight-current-row
      @current-change="selecaoLinhaHandler"
      @row-dblclick="cliqueDuploLinhaHandler"
      stripe
      empty-text="Nenhuma Administradora encontrada"
      height="250"
    >
      <el-table-column prop="nome" label="Nome" sortable>
        <template slot-scope="scope">
          <strong>{{ scope.row.nome }}</strong>
        </template>
      </el-table-column>
    </el-table>

    <span slot="footer" class="dialog-footer">
      <el-button
        @click="gravar"
        size="small"
        type="success"
        round
        class="btn-box-shadow"
      >
        Selecionar
      </el-button>

      <el-button
        @click="fechar"
        size="small"
        type="danger"
        round
        class="btn-box-shadow"
      >
        Fechar
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  props: {
    visibility: Boolean
  },
  data() {
    return {
      administradoraPesquisa: { nome: undefined },
      administradoraSelecionada: undefined
    }
  },
  computed: {
    ...mapState('condominiosStore', {
      administradoras(state) { return state.listaAdministradoras },
      condominio(state) { return state.condominioSelecionado }
    }),
    administradorasFiltradas() {
      return this.administradoras
        .filter((administradora) => {
          return (
            !this.administradoraPesquisa.nome ||
             administradora.nome.toLowerCase().includes(this.administradoraPesquisa.nome.toLowerCase())
          )
        });
    },
    labelQuantidade() {
      let quantidade = this.administradorasFiltradas.length;
      switch(quantidade) {
        case 0:
          return "Nenhuma Administradora encontrada";
        case 1:
          return "1 Administradora encontrada";
        default:
          return `${quantidade} Administradoras encontradas`;
      }
    }
  },
  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
    ...mapActions('condominiosStore', [
      'listarAdministradoras'
    ]),
    reset() {
      this.administradoraSelecionada = undefined;
      this.administradoraPesquisa = { nome: undefined };
    },
    onOpen() {
      this.reset();

      this.showLoading();
      this.listarAdministradoras({}).then(() => {
        this.hideLoading();
      }).catch(() => {
        this.hideLoading();
      });
    },
    fechar() {
      this.$emit('close');
    },
    selecaoLinhaHandler(row) {
      this.administradoraSelecionada = row;
    },
    cliqueDuploLinhaHandler(row) {
      this.administradoraSelecionada = row;
      this.gravar();
    },
    gravar() {
      if(!this.administradoraSelecionada) {
        this.$message.warning("Selecione uma Administradora na tabela");
        return;
      }
      this.condominio.administradora = this.administradoraSelecionada;
      this.fechar();
    }
  }
}
</script>